function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { memo, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { SingletonPopover } from '../../popover/SingletonPopover';
import { ScheduleViewItem } from './ScheduleViewItem';
export var ScheduleView = memo(function (props) {
  var scheduleList = props.scheduleList,
      renderTooltip = props.renderTooltip,
      onSetValue = props.onSetValue,
      colWidth = props.colWidth,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var cls = usePrefixCls('schedule-view', {
    disabled: disabled
  });
  var rowCls = usePrefixCls('schedule-view-row');
  var itemTooltipCls = usePrefixCls('schedule-view-item-tip');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var renderItem = function renderItem(row) {
    var items = row.items;
    return items.map(function (item) {
      return React.createElement(ScheduleViewItem, Object.assign({}, item, {
        key: item.label + '_' + item.formatValue,
        style: {
          width: "".concat(colWidth, "px")
        },
        onClick: onSetValue
      }));
    });
  };

  var getPopper = function getPopper(data) {
    if (!data) {
      return null;
    }

    return React.createElement("div", {
      className: itemTooltipCls
    }, renderTooltip ? renderTooltip(data) : data.label + ' ' + data.formatValue);
  };

  return React.createElement(SingletonPopover, {
    show: show,
    placement: "top-start",
    onShow: function onShow() {
      return setShow(true);
    },
    onHide: function onHide() {
      return setShow(false);
    },
    getPopper: getPopper,
    arrow: true,
    offset: {
      x: -12,
      y: -6
    },
    arrowOffset: {
      x: 16,
      y: 0
    }
  }, React.createElement("div", {
    className: cls
  }, scheduleList.map(function (listItem) {
    return React.createElement("div", {
      className: rowCls,
      key: listItem.label
    }, renderItem(listItem));
  })));
});